export default function Footer(): JSX.Element {
  return (
    <footer className="footer">
      <div className="footer-wrapper">
        <p className="footer-wrapper__copy">Разработано для участия в HackWagon2022</p>
        <p className="footer-wrapper__copy">командой uni_terminal_os</p>
        <p className="footer-wrapper__copy">2022</p>
      </div>
    </footer>
  );
}
